import { SegmentGroup } from "@ttc3k/trekker";
import { CustomListDetailsTabEnum } from "../../CustomListDetailsTabEnum";
import { getCustomListDetailsTabsConfig } from "./getCustomListDetailsTabsConfig";
import { useTranslation } from "react-i18next";

interface CustomListDetailsTabsProps {
  currentTab: string;
  onTabChange: (value: CustomListDetailsTabEnum) => void;
}

export const CustomListDetailsTabs = ({
  currentTab,
  onTabChange,
}: CustomListDetailsTabsProps) => {
  const { t } = useTranslation();
  const tabs = getCustomListDetailsTabsConfig(t);

  // TODO: Remove this when we're ready to launch on prod
  if (tabs.length === 4 && import.meta.env.VITE_ENVIRONMENT === "production") {
    tabs.pop();
  }

  return (
    <SegmentGroup.Root
      orientation={"horizontal"}
      value={currentTab}
      onValueChange={v => onTabChange(v.value as CustomListDetailsTabEnum)}
    >
      {tabs.map(tab => (
        <SegmentGroup.Item value={tab.value} key={tab.value}>
          <span>{tab.title}</span>
        </SegmentGroup.Item>
      ))}
    </SegmentGroup.Root>
  );
};
